import React from 'react';

import { withConfig } from '../common/Block.jsx';
import { Column, Container, Row, Spaced } from '../common/Container.jsx';
import { default as Image } from '../common/Image.jsx';
import Layout from '../common/Layout.jsx';

class _ShowDescription extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this._configureContent = this._configureContent.bind(this);
        this.handleToggleExpansion = this.handleToggleExpansion.bind(this);
    }

    componentDidMount() {
        const component = this;
        component.setState({
            id: `description-${component.props.blockIdentifier}`
        }, function () {
            let timeout = 0;
            if (component.props.builder) {
                timeout = 100;
            }
            setTimeout(component._configureContent, timeout);
        });
    }

    _configureContent() {
        if (!Layout.isFrancisco(this.props.config)) {
            return;
        }
        const doc = this.props.frameDoc || document;
        const descriptionContainer = doc.getElementById(this.state.id);
        if (!descriptionContainer) {
            return;
        }
        let contentContainer = descriptionContainer.getElementsByClassName('show__description__inner');
        if (!contentContainer || !contentContainer.length) {
            descriptionContainer.style.display = 'block';
            return;
        }
        contentContainer = contentContainer[0];
        const maxLength = 1000;
        const description = contentContainer.innerHTML;
        let descriptionCollapsed, readMore;
        if (description && description.length > maxLength) {
            descriptionCollapsed = description.slice(0, (maxLength - 1)) + '...';
            contentContainer.innerHTML = descriptionCollapsed;

            const temp = descriptionContainer.getElementsByClassName('show__description');
            if (temp && temp.length > 0) {
                readMore = doc.createElement('a');
                readMore.href = '#';
                readMore.innerText = 'Read More';
                readMore.onclick = this.handleToggleExpansion;
                temp[0].appendChild(readMore);
            }
        }
        this.setState({
            descriptionCollapsed: descriptionCollapsed,
            descriptionExpanded: description,
            contentContainer: contentContainer,
            expanded: false,
            readMore: readMore
        });
        descriptionContainer.style.display = 'block';
    }

    handleToggleExpansion(event) {
        if (event) {
            event.preventDefault();
        }
        const expanded = !this.state.expanded;
        this.setState({
            expanded: expanded
        });
        if (this.state.contentContainer) {
            this.state.contentContainer.innerHTML = expanded ? this.state.descriptionExpanded : this.state.descriptionCollapsed;
        }
        if (this.state.readMore) {
            this.state.readMore.innerText = expanded ? 'Show Less' : 'Read More';
        }
    }

    render() {
        let display = this.props.data.display;
        if (!display || display.length == 0) {
            display = this.props.data.about;
        }
        if ((!display || display.length == 0) && !Layout.isFrancisco(this.props.config)) {
            return null;
        }
        let content;
        if (Layout.isFrancisco(this.props.config)) {
            let imageUrl;
            if (this.props.data.image) {
                imageUrl = Image.url(this.props.data.image, undefined, 1920);
            }
            content = (
                <Column size="12">
                    <div id={this.state.id} className="description" dangerouslySetInnerHTML={{ __html: display }} style={this.props.builder ? undefined : { display: 'none' }} />
                </Column>
            )
        } else {
            content = <div className="col col--12" dangerouslySetInnerHTML={{ __html: display }} />;
        }
        return (
            <div className="sect sect--info">
                <Container>
                    <Spaced large={true}>
                        <Row>
                            {content}
                        </Row>
                    </Spaced>
                </Container>
            </div>
        );
    }
}
const ShowDescription = withConfig(_ShowDescription);

export default ShowDescription;